import { render, staticRenderFns } from "./PageOptionsItem.vue?vue&type=template&id=12ad1f9b"
import script from "./PageOptionsItem.vue?vue&type=script&lang=js"
export * from "./PageOptionsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports